import React, { Component } from "react";
import { Container, Button, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import { Order } from "../../components";
import { AdminNav, Loading } from "../../helpers";
import "./StyleValidateCheckWeight.css";
import { Redirect } from "react-router-dom";
import {
  convertRiceTypeENToTH,
  addCommaInNumber,
} from "../../helpers/function";

class ValidateCheckWeight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CheckWeightSheet: {
        description: {
          description: [],
        },
      },
      companyNameEN: null,
      Token: "token",
      redirect: false,
      validateData: {},
      data: {
        0: {
          QuantityBags: 0,
        },
      },
      riceTypeIDAndName: {},
      pageIndex: -99,
      itemIndex: -99,
      isLoading: true,
      pastData: [],
      imagesArr: [],
      arrData: [],
    };
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentWillMount() {
    let viewCheckWeightSheetByLicenseID = axios.post(
      "https://backend1.riceinspections.com/testCB",
      {
        data: {
          licenseID:
            this.props.location.state.description[
              this.props.location.pageIndex
            ]["licenseID"],
        },
      }
    );
    let viewAllRiceTypeIDAndNamePromise = fetch(
      "https://backend1.riceinspections.com/testE"
    ).then((res) => {
      return res.json();
    });
    const url = "https://backend2.riceinspections.com";
    const licenseID =
      this.props.location.state.description[this.props.location.pageIndex][
        "licenseID"
      ];
    let weightFromLicense = fetch(`${url}/search?code=${licenseID}`).then(
      (res) => res.json()
    );
    Promise.all([
      viewCheckWeightSheetByLicenseID,
      weightFromLicense,
      viewAllRiceTypeIDAndNamePromise,
    ]).then((res) => {
      let data = res[0];
      weightFromLicense = res[1];
      let riceTypeIDAndName = res[2];
      let arrImage = [];
      if (data.data) {
        let pastData = Object.values(data.data).filter((e) => {
          return (
            e["subID"] ==
            this.props.location.state.description[
              this.props.location.pageIndex
            ]["subID"]
          );
        });
        let arrData = Object.values(data.data).filter((e) => {
          return (
            e["subID"] !=
            this.props.location.state.description[
              this.props.location.pageIndex
            ]["subID"]
          );
        });
        if (pastData.length != 0) {
          this.setState({
            ...this.state,
            isLoading: false,
            pastData: pastData,
            weightFromLicense: weightFromLicense,
            riceTypeIDAndName: riceTypeIDAndName,
            arrData: arrData,
          });
        } else {
          this.setState({
            ...this.state,
            isLoading: false,
            weightFromLicense: weightFromLicense,
            riceTypeIDAndName: riceTypeIDAndName,
            arrData: arrData,
          });
        }
      } else {
        this.setState({
          ...this.state,
          isLoading: false,
          weightFromLicense: weightFromLicense,
          riceTypeIDAndName: riceTypeIDAndName,
        });
      }
    });
    this.setState(
      {
        ...this.state,
        CheckWeightSheet: this.props.location.state,
        companyNameEN: this.props.location.state["companyNameEN"],
        rawData: this.props.location.rawData,
        pageIndex: this.props.location.pageIndex,
        itemIndex: this.props.location.itemIndex,
      },
      () => {
        this.state.CheckWeightSheet["description"][this.state.pageIndex][
          "netWeight"
        ] = parseFloat(
          this.state.CheckWeightSheet["description"][this.state.pageIndex][
            "netWeight"
          ]
        ).toFixed(3);
        this.state.CheckWeightSheet["description"][this.state.pageIndex][
          "grossWeight"
        ] = parseFloat(
          this.state.CheckWeightSheet["description"][this.state.pageIndex][
            "grossWeight"
          ]
        ).toFixed(3);
      }
    );
  }

  handleSubmit = () => {
    let { validationStatus, CheckWeightSheet } = this.state;
    if (!this.state["isSubmit"]) {
      if (validationStatus) {
        return alert("please validate");
      } else {
        this.state["isSubmit"] = true;
        this.state["validateData"]["shippingDate"] =
          CheckWeightSheet.shippingDate;
        this.state["validateData"]["licenseID"] =
          CheckWeightSheet.description[this.state.pageIndex]["licenseID"];
        this.state["validateData"]["subID"] =
          CheckWeightSheet.description[this.state.pageIndex]["subID"];
        this.state["validateData"]["jobID"] = CheckWeightSheet.jobID;
        this.state["validateData"]["requestID"] = CheckWeightSheet.requestID;
        this.state["validateData"]["quantity"] = (
          parseFloat(
            CheckWeightSheet.description[this.state.pageIndex].netWeight
          ) *
          parseInt(
            CheckWeightSheet.description[this.state.pageIndex]["bagQuantity"]
          )
        ).toFixed(4);
        this.state["validateData"]["bagQuantity"] =
          CheckWeightSheet.description[this.state.pageIndex]["bagQuantity"];
        this.state["validateData"]["grossWeight"] =
          CheckWeightSheet.description[this.state.pageIndex]["grossWeight"];
        this.state["validateData"]["netWeight"] =
          CheckWeightSheet.description[this.state.pageIndex]["netWeight"];
        this.state["validateData"]["riceTypeID"] =
          CheckWeightSheet.description[this.state.pageIndex]["riceTypeID"];
        console.log("click");
        // CheckWeightSheet['description'][this.state.pageIndex]['isComplete'] !=
        if (
          CheckWeightSheet["description"][this.state.pageIndex]["isComplete"] !=
          true
        ) {
          axios.post("https://backend1.riceinspections.com/testFE", {
            data: this.state.CheckWeightSheet,
          });
          axios
            .post("https://backend1.riceinspections.com/testCA", {
              data: { ...this.state, isNew: true },
            })
            .then((res) => {
              // console.log(res)
              if (res.data) {
                this.props.history.push({
                  pathname: "/CheckWeightTable",
                  state: {
                    ...this.state.CheckWeightSheet.shippingDate,
                    timeValue:
                      this.state.CheckWeightSheet["shippingDate"] || new Date(),
                    timeShow: this.props.location.state.timeShow || new Date(),
                  },
                });
              }
            });
        } else {
          let checkWeightID = null;
          this.state.pastData.map((d) => {
            if (d["jobID"] == this.state.itemIndex) {
              checkWeightID = d["checkWeightID"];
            }
          });
          if (checkWeightID) {
            this.state.shortCircuit = checkWeightID;
          }
          axios
            .post("https://backend1.riceinspections.com/testCA", { data: this.state })
            .then((res) => {
              // console.log(res)
              if (res.data) {
                this.props.history.push({
                  pathname: "/CheckWeightTable",
                  state: {
                    ...this.state.CheckWeightSheet.shippingDate,
                    timeValue:
                      this.state.CheckWeightSheet["shippingDate"] || new Date(),
                    timeShow: this.props.location.state.timeShow || new Date(),
                  },
                });
              }
            });
        }
      }
    }
  };
  handleSubmitAndNext = () => {
    let { validationStatus, CheckWeightSheet } = this.state;
    if (!this.state["isSubmit"]) {
      if (validationStatus) {
        return alert("please validate");
      } else {
        this.state["validateData"]["shippingDate"] =
          CheckWeightSheet.shippingDate;
        this.state["validateData"]["licenseID"] =
          CheckWeightSheet.description[this.state.pageIndex]["licenseID"];
        this.state["validateData"]["subID"] =
          CheckWeightSheet.description[this.state.pageIndex]["subID"];
        this.state["validateData"]["jobID"] = CheckWeightSheet.jobID;
        this.state["validateData"]["requestID"] = CheckWeightSheet.requestID;
        this.state["validateData"]["quantity"] = (
          parseFloat(
            CheckWeightSheet.description[this.state.pageIndex].netWeight
          ) *
          parseInt(
            CheckWeightSheet.description[this.state.pageIndex]["bagQuantity"]
          )
        ).toFixed(4);
        this.state["validateData"]["bagQuantity"] =
          CheckWeightSheet.description[this.state.pageIndex]["bagQuantity"];
        this.state["validateData"]["grossWeight"] =
          CheckWeightSheet.description[this.state.pageIndex]["grossWeight"];
        this.state["validateData"]["netWeight"] =
          CheckWeightSheet.description[this.state.pageIndex]["netWeight"];
        this.state["validateData"]["riceTypeID"] =
          CheckWeightSheet.description[this.state.pageIndex]["riceTypeID"];

        // console.log(this.state['validateData'])
        if (
          CheckWeightSheet["description"][this.state.pageIndex]["isComplete"] !=
          true
        ) {
          this.setState({
            ...this.state,
            isLoading: true,
          });

          axios.post("https://backend1.riceinspections.com/testFE", {
            data: this.state.CheckWeightSheet,
          });
          axios
            .post("https://backend1.riceinspections.com/testCA", {
              data: {
                ...this.state,
                isNew: true,
              },
            })
            .then((res) => {
              // console.log(res)
              if (res.data) {
                let data = this.state.rawData;
                let jobID = this.state.itemIndex;
                let desIndex = this.state.pageIndex;
                let currentIdx = -1;
                data.map((dataItem, idx) => {
                  if (dataItem["jobID"] == jobID) {
                    currentIdx = idx;
                    if (dataItem["description"][parseInt(desIndex) + 1]) {
                      desIndex += 1;
                    } else {
                      desIndex = 0;
                      currentIdx += 1;
                      if (!data[currentIdx]) {
                        currentIdx = -99;
                      }
                    }
                  }
                });

                let viewCheckWeightSheetByLicenseID = axios.post(
                  "https://backend1.riceinspections.com/testCB",
                  {
                    data: {
                      licenseID:
                        data[currentIdx]["description"][desIndex]["licenseID"],
                    },
                  }
                );
                const url = "https://backend2.riceinspections.com";
                const licenseID =
                  data[currentIdx]["description"][desIndex]["licenseID"];
                let weightFromLicense = fetch(
                  `${url}/search?code=${licenseID}`
                ).then((res) => res.json());

                Promise.all([
                  viewCheckWeightSheetByLicenseID,
                  weightFromLicense,
                ]).then((res) => {
                  let pastData = [];
                  let dataItem = res[0];
                  weightFromLicense = res[1];
                  if (dataItem.data) {
                    pastData = Object.values(dataItem.data).filter((e) => {
                      return (
                        e["subID"] ==
                        data[currentIdx].description[desIndex]["subID"]
                      );
                    });
                    if (pastData.length != 0) {
                      this.setState(
                        {
                          ...this.state,
                          CheckWeightSheet: data[currentIdx],
                          companyNameEN: data[currentIdx]["companyEN"],
                          isLoading: false,
                          pageIndex: desIndex,
                          itemIndex: -99,
                          pastData: pastData,
                          weightFromLicense: weightFromLicense,
                          validateData: {
                            ...this.state.validateData,
                            bagQuantity: undefined,
                          },
                        },
                        () => {
                          this.setState({
                            ...this.state,
                            itemIndex: data[currentIdx]["jobID"],
                          });
                        }
                      );
                    } else {
                      this.setState(
                        {
                          ...this.state,
                          CheckWeightSheet: data[currentIdx],
                          companyNameEN: data[currentIdx]["companyEN"],
                          isLoading: false,
                          pageIndex: desIndex,
                          itemIndex: -99,
                          pastData: pastData,
                          weightFromLicense: weightFromLicense,
                          validateData: {
                            ...this.state.validateData,
                            bagQuantity: undefined,
                          },
                        },
                        () => {
                          this.setState({
                            ...this.state,
                            itemIndex: data[currentIdx]["jobID"],
                          });
                        }
                      );
                    }
                  } else {
                    console.log(currentIdx, desIndex);
                    this.setState(
                      {
                        ...this.state,
                        CheckWeightSheet: data[currentIdx],
                        companyNameEN: data[currentIdx]["companyEN"],
                        isLoading: false,
                        pageIndex: desIndex,
                        itemIndex: -99,
                        pastData: pastData,
                        weightFromLicense: weightFromLicense,
                        validateData: {
                          ...this.state.validateData,
                          bagQuantity: undefined,
                        },
                      },
                      () => {
                        this.setState({
                          ...this.state,
                          itemIndex: data[currentIdx]["jobID"],
                        });
                      }
                    );
                  }
                });
              }
            });
        }
      }
    }
  };

  handleButtonClick = (id, value, idx) => {
    // console.log(this.state)
    if (value !== "undefined") {
      // console.log(value)
      value = value.replace(/,/gi, "");
      let data = this.state.validateData;
      // console.log(id,value)
      data[id] = value;
      data["licenseID"] =
        this.state.CheckWeightSheet.description[idx]["licenseID"];
      data["subID"] = this.state.CheckWeightSheet.description[idx]["subID"];
      data["jobID"] = this.state.CheckWeightSheet.jobID;
      this.state.CheckWeightSheet.description[idx][id] = value;
      this.setState({
        ...this.state,
        validateData: {
          ...this.state.validateData,
          [id]: value,
        },
      });
      this.setState({
        ...this.state,
        CheckWeightSheet: this.state.CheckWeightSheet,
      });
    }
  };
  renderRedirectToJob() {
    if (this.state.redirect) {
      this.props.history.push({
        pathname: "/CheckWeightTable",
        state: {
          ...this.state.CheckWeightSheet.shippingDate,
          timeValue: this.state.CheckWeightSheet["shippingDate"] || new Date(),
          timeShow: this.props.location.state.timeShow || new Date(),
        },
      });
    }
  }
  renderTableHistory(arrData, LicenseDetail, licenseID) {
    if (!Array.isArray(LicenseDetail)) {
      LicenseDetail = [LicenseDetail];
    }
    return LicenseDetail.map((licenseData, idz) => {
      let totalWeight =
        (licenseData["netWeight"] * licenseData["bagQuantity"]) / 1000 || 0;

      let KGM = LicenseDetail[idz]?.["NetWeightKGM"];
      if (!Number.isFinite(KGM)) {
        KGM = parseFloat(KGM.replace(",", ""));
      }

      return (
        <Table bordered hover style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                วันที่บรรทุก
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                เลขทะเบียนงาน
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                เลขที่ใบอนุญาต
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                netWeight
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                grossWeight
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                ปริมาณ / ตัน
              </th>
              <th
                style={{ width: "13.7%", overflow: "auto", fontSize: "11px" }}>
                จำนวนกระสอบ
              </th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              let totalData = arrData.filter((e) => {
                return e["subID"] == idz;
              });
              if (totalData.length != 0) {
                return totalData.map((data, idx) => {
                  totalWeight +=
                    (data["netWeight"] * data["bagQuantity"]) / 1000;
                  return (
                    <tr id={idx}>
                      <td style={{ width: "13.7%", fontSize: "13px" }}>
                        <b>{data["shippingDate"]}</b>
                      </td>
                      <td style={{ width: "13.7%", fontSize: "13px" }}>
                        <b>{data["jobID"]} </b>
                      </td>
                      <td style={{ width: "13.7%", fontSize: "13px" }}>
                        <b>
                          {data["licenseID"]}({parseInt(data["subID"]) + 1})
                        </b>
                      </td>
                      <td
                        style={{
                          width: "13.7%",
                          overflow: "auto",
                          fontSize: "13px",
                        }}>
                        <b>{parseFloat(data["netWeight"]).toFixed(4)}</b>
                      </td>
                      <td
                        style={{
                          width: "13.7%",
                          overflow: "auto",
                          height: "100%",
                          fontSize: "13px",
                        }}>
                        <b>{parseFloat(data["grossWeight"]).toFixed(4)}</b>
                      </td>
                      <td style={{ width: "13.7%", fontSize: "13px" }}>
                        <b>
                          {(
                            (data["netWeight"] * data["bagQuantity"]) /
                            1000
                          ).toFixed(4)}
                        </b>
                      </td>
                      <td
                        style={{
                          overflow: "auto",
                          width: "13.7%",
                          fontSize: "13px",
                        }}>
                        <b>{data["bagQuantity"]}</b>
                      </td>
                    </tr>
                  );
                });
              }
            })()}
            <tr id={idz}>
              <td style={{ width: "13.7%", fontSize: "13px" }}>
                <b></b>
              </td>
              <td style={{ width: "11.7%", fontSize: "13px" }}>
                <b></b>
              </td>
              <td style={{ width: "13.7%", fontSize: "13px" }}>
                <b>
                  {licenseID}({parseInt(idz) + 1}){" "}
                </b>
              </td>
              <td
                style={{ width: "14.7%", overflow: "auto", fontSize: "13px" }}>
                <b></b>
              </td>
              <td
                style={{
                  width: "14.7%",
                  overflow: "auto",
                  height: "100%",
                  fontSize: "13px",
                }}>
                <b>
                  น้ำหนักทั้งหมด <br /> {(KGM / 1000).toFixed(4)} ตัน
                </b>
              </td>
              <td style={{ width: "13.7%", fontSize: "13px" }}>
                <b>
                  ลงไปแล้ว <br /> {totalWeight.toFixed(4)} ตัน
                </b>
              </td>
              <td
                style={{ overflow: "auto", width: "13.7%", fontSize: "13px" }}>
                <b>
                  คงเหลือ <br /> {(KGM / 1000 - totalWeight).toFixed(4)} ตัน
                </b>
              </td>
            </tr>
          </tbody>
        </Table>
      );
    });
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj);
    let day = dateParser.getDate();
    let month = dateParser.getMonth() + 1;
    let years = dateParser.getFullYear() + 543;
    return `${day}/${month}/${years}`;
  }
  getCompanyName(companyObj) {
    let viewAllCompany = this.props.location.companyAll;
    let outputCompany = null;
    Object.values(viewAllCompany).map((companyData) => {
      if (
        companyData["companyNameTH"].replace(/\s/g, "").trim() ==
        companyObj.replace(/\s/g, "").trim()
      ) {
        outputCompany = companyData["companyNameEN"];
      }
    });
    if (companyObj == "ไทยฮาจำกัด") {
      outputCompany = "THAI HA PUBLIC CO., LTD.";
    } else if (companyObj == "ไทยฟ้า(2511)จำกัด") {
      outputCompany = "THAI HUA (2511) CO., LTD.";
    }
    if (outputCompany) {
      return outputCompany;
    } else {
      return companyObj;
    }
  }
  renderExpireDate(exp) {
    let years = exp?.slice(exp.length - 4, exp.length);
    years = parseInt(years) + 543;
    return `${exp?.slice(0, exp.length - 4)}${years}`;
  }
  handleCancel() {
    if (window.confirm("ยืนยันการยกเลิกใบ checkWeight")) {
      let pastData = this.state.pastData.filter(
        (o) =>
          o.jobID == this.state.itemIndex && o.subID == this.state.pageIndex
      );
      if (pastData.length > 0) {
        axios
          .post(
            // 'https://backend1.riceinspections.com/testGF',
            "https://backend1.riceinspections.com/testGF",
            {
              data: {
                checkWeightID: pastData[0]["checkWeightID"],
              },
            }
          )
          .finally(() => {
            this.props.history.push({
              pathname: "/CheckWeightTable",
              state: {
                ...this.state.CheckWeightSheet.shippingDate,
                timeValue:
                  this.state.CheckWeightSheet["shippingDate"] || new Date(),
                timeShow: this.props.location.state.timeShow || new Date(),
              },
            });
          });
      } else {
        alert("หาใบ Checkweight ไม่พบ");
      }
    }
  }
  render() {
    let { CheckWeightSheet, data, companyNameEN } = this.state;
    if (!CheckWeightSheet) {
      return <div />;
    } else if (this.state.isLoading == true) {
      return (
        <Container>
          {this.renderRedirectToJob()}
          <Loading></Loading>
          <div>
            <Row>
              <Col>
                <AdminNav />
              </Col>
            </Row>
          </div>
          <div
            style={{
              width: "100%",
              alignContent: "left",
              textAlign: "left",
              fontSize: "22px",
            }}>
            <a
              href="javascript:void(0)"
              onClick={() => {
                this.setState({
                  ...this.state,
                  redirect: true,
                });
              }}>
              {" "}
              {`<`} ย้อนกลับ {console.log(CheckWeightSheet["shippingDate"])}
            </a>
          </div>

          <Order
            riceTypeIDAndName={this.state.riceTypeIDAndName}
            desIndex={this.state.pageIndex}
            jobIndex={this.state.itemIndex}
            handleSubmitAndNext={this.handleSubmitAndNext}
            handleSubmit={this.handleSubmit}
            CheckWeightSheet={CheckWeightSheet}
            companyNameEN={companyNameEN}
            handleButtonClick={this.handleButtonClick}
            data={data}
          />
        </Container>
      );
    } else if (this.state.isLoading == false) {
      return (
        <Container>
          {this.renderRedirectToJob()}
          <div>
            <Row>
              <Col>
                <AdminNav />
              </Col>
            </Row>
          </div>
          <div
            style={{
              width: "100%",
              alignContent: "left",
              textAlign: "left",
              fontSize: "22px",
            }}>
            <a
              href="javascript:void(0)"
              onClick={() => {
                this.setState({
                  ...this.state,
                  redirect: true,
                });
              }}>
              {" "}
              {`<`} ย้อนกลับ
            </a>
          </div>
          {/* {console.log(this.state.weightFromLicense)} */}
          <Order
            riceTypeIDAndName={this.state.riceTypeIDAndName}
            imagesArr={this.state.imagesArr}
            desIndex={this.state.pageIndex}
            jobIndex={this.state.itemIndex}
            handleSubmitAndNext={this.handleSubmitAndNext}
            handleSubmit={this.handleSubmit}
            handleButtonClick={this.handleButtonClick}
            CheckWeightSheet={CheckWeightSheet}
            pastData={this.state.pastData}
            pp={this.state.weightFromLicense?.PaperlessDetail?.LicenseDetail}
            subID={
              this.props.location.state.description[this.state.pageIndex][
                "subID"
              ]
            }
            validateData={this.state.validateData}
            companyNameEN={this.getCompanyName(
              this.state.CheckWeightSheet.companyID
            )}
          />

          <br />
          <br />

          <Table bordered hover style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th style={{ overflow: "auto", fontSize: "18px" }}>
                  ใบอนุญาตเลขที่{" "}
                </th>
                <th>
                  {CheckWeightSheet.description[this.state.pageIndex][
                    "licenseID"
                  ].slice(
                    6,
                    CheckWeightSheet.description[this.state.pageIndex][
                      "licenseID"
                    ].length
                  )}
                </th>
                <th style={{ overflow: "auto", fontSize: "18px" }}>
                  วันหมดอายุ{" "}
                </th>
                <th>
                  {this.renderExpireDate(
                    this.state.weightFromLicense["ExpiredDate"]
                  )}
                </th>
              </tr>
              <tr>
                <th style={{ overflow: "auto", fontSize: "18px" }}>
                  รายการที่{" "}
                </th>
                <th>น้ำหนักสุทธิ</th>
                <th style={{ overflow: "auto", fontSize: "18px" }}>
                  สกุลเงิน{" "}
                </th>
                <th>อัตราแลกเปลี่ยน</th>
                <th>ราคาต่อหน่วย</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                let totalWeight = 0;
                // let c = this.state.viewAllSurveyRequestSheetByDate[data]
                let pp =
                  this.state.weightFromLicense?.PaperlessDetail?.LicenseDetail;
                if (!Array.isArray(pp)) {
                  pp = [pp];
                }
                console.log(pp);
                let licenseID =
                  CheckWeightSheet.description[this.state.pageIndex][
                    "licenseID"
                  ];
                let subID =
                  CheckWeightSheet.description[this.state.pageIndex]["subID"];
                let lastWeight = pp[subID]?.["NetWeightKGM"];

                if (!Number.isFinite(lastWeight)) {
                  lastWeight = parseFloat(lastWeight?.replace(",", ""));
                }
                // console.log(pp[subID]['Quantity'])
                return (
                  <tr id={0}>
                    <td style={{ width: "13.7%", fontSize: "13px" }}>
                      <b>({parseInt(subID) + 1})</b>
                    </td>
                    <td style={{ width: "13.7%", fontSize: "13px" }}>
                      <b>
                        {" "}
                        {addCommaInNumber(lastWeight?.toFixed(4))} /{" "}
                        {pp[subID]?.["Quantity"]} {pp[subID]?.["QuantityUnit"]}
                      </b>
                    </td>
                    <td
                      style={{
                        width: "13.7%",
                        overflow: "auto",
                        fontSize: "13px",
                      }}>
                      <b>{this.state.weightFromLicense["Currency"]}</b>
                    </td>
                    <td
                      style={{
                        width: "13.7%",
                        overflow: "auto",
                        height: "100%",
                        fontSize: "13px",
                      }}>
                      <b>{this.state.weightFromLicense["ExchangeRate"]}</b>
                    </td>
                    <td
                      style={{
                        overflow: "auto",
                        width: "13.7%",
                        fontSize: "13px",
                      }}>
                      <b>{pp[subID]?.["PricePerUnit"]}</b>
                    </td>
                  </tr>
                );
              })()}
            </tbody>
          </Table>
          {/* {this.renderTableHistory(this.state.arrData,this.state.weightFromLicense.PaperlessDetail.LicenseDetail,this.state.weightFromLicense['_id'])} */}
          <div className="text-right">
            {/* <Button disabled={true} onClick={() => { }}>
              จองเลขที่ใบรับรอง
          </Button> */}
            &nbsp;&nbsp;&nbsp;
            <Button onClick={this.handleCancel}>ยกเลิกงาน</Button>
          </div>
        </Container>
      );
    }
  }
}

export default ValidateCheckWeight;
// PE = in new single polyethylene bags of
// Inner PE / Outer PE Bag = in double bags (inner : plastic and outer : plastic) of
